// components/Compliance/MandatoryBlockedListener.js
// ──────────────────────────────────────────────────────────────────────────────
// Listens for `vc-mandatory-blocked` events fired by apiClient when the BE
// returns 403 + code MANDATORY_BLOCKED. Shows a non-dismissable modal with a
// CTA that redirects the student to /s/compliance.
// ──────────────────────────────────────────────────────────────────────────────

import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ShieldAlert } from 'lucide-react';
import { ConfirmModal } from '../ui';

export default function MandatoryBlockedListener() {
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState('');
  const [target, setTarget] = useState('/s/compliance');

  useEffect(() => {
    const handler = (e) => {
      // Don't show the modal on the compliance page itself.
      if (location.pathname.startsWith('/s/compliance')) return;
      setMsg(e.detail?.message || 'You have overdue mandatory training. Please complete it to continue.');
      setTarget(e.detail?.redirectTo || '/s/compliance');
      setOpen(true);
    };
    window.addEventListener('vc-mandatory-blocked', handler);
    return () => window.removeEventListener('vc-mandatory-blocked', handler);
  }, [location.pathname]);

  if (!open) return null;
  return (
    <ConfirmModal
      show={open}
      onHide={() => setOpen(false)}
      title="Mandatory Training Overdue"
      message={msg}
      icon={<ShieldAlert size={22} />}
      confirmText="Go to My Training"
      cancelText="Dismiss"
      variant="warning"
      onConfirm={() => {
        setOpen(false);
        navigate(target);
      }}
    />
  );
}
